import { render, staticRenderFns } from "./SupplierOrderEdit.vue?vue&type=template&id=897b55e0"
import script from "./SupplierOrderEdit.vue?vue&type=script&lang=js"
export * from "./SupplierOrderEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports